export default __webpack_public_path__ + "static/hero-pattern-c4211ab90dacc996ffa13d891248f855.png";